/* src/app/shared/components/file-viewer/file-viewer.component.css */
/*# sourceMappingURL=file-viewer.component-BYCUOFHC.css.map */
